import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    if (!this.authService.isAuthenticated()) {
      const restored = await this.authService.restoreSessionFromStorage();
      if (!restored) {
        this.router.navigate(['/login'], { replaceUrl: true });
        return false;
      }
    }
    const valid = await this.authService.verifySessionWithBackend();
    if (!valid) {
      // Backend rejected the access JWT — try one refresh before kicking to /login.
      const refreshed = await this.authService.refreshAccessTokenIfPossible();
      if (!refreshed) {
        await this.authService.invalidateLocalSession();
        this.router.navigate(['/login'], { replaceUrl: true });
        return false;
      }
    }
    return true;
  }
}
